<template>

    <div class="cents">
        <van-nav-bar
        :title="$t('ryzc')"
        left-arrow
        safe-area-inset-top
        style="background-color: #1ABC9C;"
        @click-left="goto"
        />
        <div class="selfcents">
            <div class="lisone margin_tops phone">
                <span class="name">{{$t('sjhm')}}:</span>
				<select @click="selectHand">
				    <option :value ="this.address">{{this.address}}</option>
				</select>
                <div class="inputsp">
                    <input type="text" v-model="mobile">
                    <span>*</span>
                </div>
            </div>
            <div class="lisone margin_tops">
                <span class="name">{{$t('xm')}}:</span>
                <div class="inputsp">
                    <input type="text" v-model="name">
                    <span style="">*</span>
                </div>
            </div>
            <div class="lisone margin_tops">
                <span class="name" style="line-height: 80px;">{{$t('rlzp')}}:</span>
                <img class="imgs" :src="img" alt="" v-if="this.img">
                <div v-else style="border-radius:50%;border: 1px solid #ccc;width:80px;height:80px"></div>
                <div class="filediv">
                    <div class="btnn fileinput-buttom">
                        <span>{{$t('tj')}}</span>
                        <h5-cropper :option="option" 
                        @getbase64Data="getbase64Data" 
                        @getblobData="getblobData" 
                        @getFile="getFile"
                        
                        @canceltailor="canceltailor"></h5-cropper>
                    </div>
                </div>
            </div>

            <div class="lisone margin_tops">
                <span class="name">{{$t('zjlx')}}:</span>
                <div class="inputsp">
                    <select v-model="credential_type">
                        <option value ="0">{{$t('sfz')}}</option>
                        <option value ="1">{{$t('hz')}}</option>
                        <option value ="2">{{$t('jzz')}}</option>
                        <option value ="3">{{$t('jsz')}}</option>
                    </select>
                    <span style=""></span>
                </div>
            </div>

            <div class="lisone margin_tops">
                <span class="name">{{$t('zjh')}}:</span>
                <div class="inputsp">
                    <input type="text" v-model="credential">
                    <span style=""></span>
                </div>
            </div>

            <div class="lisone margin_tops">
                <span class="name">{{$t('xb')}}:</span>
                <div class="inputsp">
                    <select v-model="gender">
                        <option value ="0">{{$t('nbool')}}</option>
                        <option value ="1">{{$t('ngril')}}</option>
                    </select>
                    <span style=""></span>
                </div>
            </div>


            <div class="lisone margin_tops">
                <span class="name">{{$t('jg')}}:</span>
                <div class="inputsp">
                    <input type="text" v-model="origin">
                    <span style=""></span>
                </div>
            </div>


             <div class="lisone margin_tops">
                <span class="name">{{$t('hj')}}:</span>
                <div class="inputsp">
                    <input type="text" v-model="birthplace">
                    <span style=""></span>
                </div>
            </div>

            <div class="lisone margin_tops" v-if="this.$i18n.locale == 'cn'">
                <span class="name">{{$t('sfcs')}}:</span>
                <div class="inputsp" @click="showPopup">
                    <input type="text" readonly v-model="po">
                    <span style=""></span>
                </div>

                <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
                    <van-area  :columns-num='2' :area-list="areaList"  @confirm="ss" />
                </van-popup>
            </div>  

            <div class="lisone margin_tops" v-else>
                <span class="name">{{$t('sfcs')}}:</span>
                <div class="inputsp">
                    <input type="text"  v-model="city">
                    <span style=""></span>
                </div>

                
            </div>  



            <div class="lisone margin_tops">
                <span class="name">{{$t('qybm')}}:</span>
                <div class="inputspy">
                    <div class="inputsp" @click="showDep">
                        <input type="text" disabled="disabled" v-model="dept_name">
                        <span style="">*</span>
                    </div>
                    <van-popup v-model="show2" position="bottom" :style="{ height: '50%' }">
                        <div  style="padding:10px 10px">
                           
                             <a-tree
                             style="text-align: left;"
                                v-if="treeData.length"
                                :checkable="true"
                                v-model="checkedSiteId"
                                :checkStrictly="true"
                                :tree-data="treeData"
                                defaultExpandAll
                                ref="treeForm"
                                :replaceFields="{children:'children', title:'name', key:'id' }"
                                @onSelect="onSelect"
                                @check="handleNodeClick"
                                >
                            </a-tree>
                            
                        </div>
                    </van-popup>
                    
                </div>
            </div>
             <!-- <div class="lisone margin_tops">
                <span class="name">{{$t('kh')}}:</span>
                <div class="inputsp">
                    <input type="text" v-model="card_no">
                    <span style=""></span>
                </div>
            </div> -->
             <div class="lisone margin_tops">
                <span class="name">{{$t('kmmm')}}:</span>
                <div class="inputsp">
                    <input type="text" v-model="door_password">
                    <span style="">*</span>
                </div>
            </div>
            <div class="lisone margin_tops">
                <span class="name">{{$t('gh')}}:</span>
                <div class="inputsp">
                    <input type="text" v-model="number">
                    <span style="">*</span>
                </div>
            </div>

           

            <van-button  class="buts" color="#48C9B0" @click="submitSelf">{{$t('qd')}}</van-button>
        
          

        </div>
         <Footer :active="active"></Footer>
         
    </div>
</template>

<script>


// import tree from "vue-giant-tree";
import H5Cropper  from 'vue-cropper-h5'
import methodlist from "@/utils/methods";
import { Toast } from 'vant';
import jq from 'jquery'
var Base64 = require("js-base64").Base64;
import {areaList} from '@/utils/city.js'




export default {
  components: { H5Cropper },
  data(){
    return{
		address:localStorage.getItem('address')?localStorage.getItem('address'):'+86',
        replaceFields:{children:'children', title:'name', key:'id' },
        treeData:[],
        autoExpandParent: true,
        checkStrictly:true,
        defaultExpandAll:true,
        

        name:'',
        mobile:'',
        credential_type:'',
        credential:'',
        gender:'',
        origin:"",
        birthplace:'',
        province:'',
        city:'',
        number:'',
        dept_id:'',
        dept_name:'',
        door_password:'',
        card_no:'',

        nodes: [{ id:1, pid:0, name:this.$t('sygx1'), open:true}, ],
        activeId: 1,
        activeIndex: 0,
        active: 1,
        show: false,
        show2:false,
        po:null,
        areaList :areaList,
        UserInfo:JSON.parse(window.localStorage.getItem("getTokendata")),
        option:{
            cancelButtonText: this.$t('qx'),
			confirmButtonText: this.$t('qd'),
            outputType:"jpeg",
            ceilbutton:true, //按钮在上
            autoCrop: true, // 是否默认生成截图框
            autoCropWidth: 200, // 默认生成截图框宽度
            autoCropHeight: 250, // 默认生成截图框高度
            // 截图框的宽高比例
            fixedNumber: [1, 1.25],
            // 固定截图框大小 不允许改变
            fixedBox: true,
            canMove: true, // 上传图片是否可以移动
            fixed: true, // 是否开启截图框宽高固定比例
            canMoveBox: true, // 截图框能否拖动
            original: true, // 上传图片按照原始比例渲染
            centerBox: true, // 截图框是否被限制在图片里面
            height: true,
            infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
            enlarge: 1, // 图片根据截图框输出比例倍数
            mode: 'container', // 图片默认渲染方式
            high:false,
            maxImgSize: 640 // 限制图片最大宽度和高度
        },
        img:'',
        faceimg: {
            up_img_name_src: "", //原始名字
            up_img_name_dst: "", //修改名字
            person_id: "", //员工id
            up_img_flag: 0, //上传图片标志
        },
        headers:null,

        
        checkedSiteId: [],
        
    }
  },
  mounted(){
       this.faceimg.up_img_flag = 0;
      this.getDemp()
  },
  methods:{
      onSelect(selectedKeys, info) {
      console.log('selected', selectedKeys, info);
    },
	selectHand(){
	    this.$router.push({path:'/indexbar'})
	    
	},
     handleNodeClick(checkedKeys,info) {
       
       if(info.checkedNodes.length==1){
          this.dept_name =  info.checkedNodes[0].data.props.name
       }else{
          this.dept_name =  info.checkedNodes[1].data.props.name
       }
        this.checkedSiteId = [].concat(checkedKeys.checked[checkedKeys.checked.length - 1]);
        this.dept_id = this.checkedSiteId[0]

        this.$nextTick(() => {
           if (this.checkedSiteId.length > 0) {
               this.siteActiveName = 'first';
               
           } else {
            //    return this.$message.info('请选择项目进行查询');
           }
       });
     },


      // 返回
    goto(){
        this.$router.go(-1)
    },
    
    


    showPopup(){
        this.show = true;
    },
    showDep(){
        this.show2 = true
        // this.$router.push({ path: '/trees' })
    },
    ss(val){
        this.po = val[0].name + '/' + val[1].name
        this.province = val[0].name
        this.city = val[1].name
        this.show = false
    },
    
    // 提交注册
    submitSelf(){

        if(!this.mobile){
             Toast.fail(this.$t('qtxsjhm'));
             return false
        }
        if(!this.name){
             Toast.fail(this.$t('qtxxm'));
             return false
        }
        if(!this.dept_id){
             Toast.fail(this.$t('qxzbm'));
             return false
        }
        if(!this.door_password){
             Toast.fail(this.$t('qxkmmm'));
             return false
        }
        if(!this.number){
             Toast.fail(this.$t('qxgh'));
             return false
        }
       let mobiles
       if(this.address=="+86"){
           mobiles =this.mobile
       }else{
           mobiles =this.address+'-'+ this.mobile
       }
        let data ={
            method:'co.wx.person.add',
            name:this.name,
            mobile:mobiles,
            credential_type:this.credential_type,
            credential:this.credential,
            gender:this.gender,
            origin:this.origin,
            birthplace:this.birthplace,
            province:this.province,
            city:this.city,
            agent_id:this.UserInfo.agent_id,
            user_id:this.UserInfo.user_id,
            dept_id:this.dept_id,
            number:this.number,
            card_no:this.card_no,
            door_password:this.door_password
        }
        console.log(this.dept_id)
        this.$serve(data).then(res=>{
            console.log(`09`,res)
            if(res.data.code==0){
                this.faceimg.person_id = res.data.data.id;
                if (this.faceimg.up_img_flag == 1) this.deletePersonOldFaceImg();
                this.renamePersonImgName(res.data.data.id)
                Toast.success(this.$t('zccg'));
                this.$router.go(-1)
            }else{
                Toast.fail(this.$t('zcsb'));
            }
        })
        
    },
    //修改人脸图片的名称
    renamePersonImgName(id) {
      let id8HexUp = this.imgHexNameFromPersonId();
      this.faceimg.up_img_name_dst = methodlist.type_face + id8HexUp + ".jpg";

      if (
        this.faceimg.up_img_name_src.length == 0 ||
        this.faceimg.up_img_name_dst.length == 0
      ) {
        console.log("图片文件路径错误！");
        return false;
      }

      let mqttInfo =
        this.UserInfo.mqtt_serial + ":" + this.UserInfo.mqtt_password;

      //mqttInfo = '0AwAA:81905683';//测试用

      var data = "temporary=true&rename=" + this.faceimg.up_img_name_dst;
      var _this = this;
      jq.ajax({
        headers: {
          Authorization: "Basic " + Base64.encode(mqttInfo),
          "Content-MD5": _this.$md5(data),
        },
        url: methodlist.upload_img_base + _this.faceimg.up_img_name_src,
        type: "POST",
        contentType: "application/x-www-form-urlencoded",
        data: data,
        success: function (res) {
          console.log("改名成功:", res);
          _this.freshServerImgName(id,res);
        },
        error: function (res) {
          console.log("改名失败:", res);
        },
      });
    },

    //删除没用的人脸图片
    deletePersonOldFaceImg() {
      let mqttInfo =
        this.UserInfo.mqtt_serial + ":" + this.UserInfo.mqtt_password;
      //mqttInfo = '0AwAA:81905683';//测试用
      var id8HexUp = this.imgHexNameFromPersonId();
      var delImgPath =
        methodlist.upload_img_base + methodlist.type_face + id8HexUp + ".jpg";
      var data = "";
      var _this = this;
      jq.ajax({
        headers: {
          Authorization: "Basic " + Base64.encode(mqttInfo),
          "Content-MD5": data,
        },
        url: delImgPath,
        type: "DELETE",
        contentType: "false",
        data: data,
        success: function (res) {
          console.log("删除人脸图片OK", JSON.stringify(res));
          _this.deletePersonOldFaceTemp();
        },
        error: function (res) {
          console.log("删除人脸图片Err", JSON.stringify(res));
          _this.deletePersonOldFaceTemp();
        },
      });
    },
    //删除没用的人脸模板
    deletePersonOldFaceTemp() {
      let mqttInfo =
        this.UserInfo.mqtt_serial + ":" + this.UserInfo.mqtt_password;
      //mqttInfo = '0AwAA:81905683';//测试用

      var id8HexUp = this.imgHexNameFromPersonId();
      var delFaceTempUrl =
        methodlist.upload_img_base + methodlist.type_temp + id8HexUp + ".bin";
      var data = "";
      var _this = this;
      jq.ajax({
        headers: {
          Authorization: "Basic " + Base64.encode(mqttInfo),
          "Content-MD5": data,
        },
        url: delFaceTempUrl,
        type: "DELETE",
        contentType: "false",
        data: data,
        success: function (res) {
          console.log("删除人脸模板OK", JSON.stringify(res));
          setTimeout(() => {
            _this.renamePersonImgName();
          }, 2 * 1000);
        },
        error: function (res) {
          console.log("删除人脸模板Err", JSON.stringify(res));
          setTimeout(() => {
            _this.renamePersonImgName();
          }, 2 * 1000);
        },
      });
    },
    imgHexNameFromPersonId() {
      //this.faceimg.person_id = 1000;
      let num = parseInt(this.faceimg.person_id).toString(16);
      let id8Hex = ("00000000" + num).slice(-8);
      let id8HexUpName = id8Hex.toUpperCase();
      return id8HexUpName;
    },
    // 图片更新到服务器
    freshServerImgName(person_id,img_url) {

        
      const params = {
        method: 'co.wx.face.update',
        user_id: person_id,
        pic_url: img_url
      };
      this.$serve(params).then((res) => {
        console.log(res);
        if (res.data.code != 0) {
          Toast.fail(this.$t('tpgxsb'));
        }
      });
    },

    // 获取部门id
    // Delivercont(id){
    //     console.log(`99`,id)
    // },
    getDemp(){
        let data ={
            method:'co.wx.dept.list',
            user_id:this.UserInfo.user_id,
            agent_id:this.UserInfo.agent_id
        }
        this.$serve(data).then(res=>{
            console.log(`5`,res.data.data)
            var result = [];
            if (res.data.data != null) result.push(this.getFirstObj(res.data.data));
            this.treeData = result;
            // this.treeData=this.getFirstObj(res.data.data)
            // console.log(`6`,this.treeData)
        })
    },

    getFirstObj(obj){
        for(var key in obj){
            return obj[key];
        }
    },
   
    //  裁剪后base64返回
    getbase64Data(data) {
      this.img = data;
      console.log(`0`,data)
    },
    getblobData(data){
        console.log(`1`,data)
    },
    getFile(data){
       let filex = data
       var reader = new FileReader();
       let _this = this; 
       reader.readAsDataURL(filex);
       reader.onload = function (e) {
           let es = e.target.result;
           console.log(`909`,es)
            let mqttInfo =
            _this.UserInfo.mqtt_serial + ":" + _this.UserInfo.mqtt_password;
            let curTimestamp = new Date().getTime();
            _this.faceimg.up_img_name_src =methodlist.type_face + curTimestamp + ".jpeg";

            let up_url_Path =methodlist.upload_img_base + _this.faceimg.up_img_name_src;
            
            _this.action = up_url_Path;
            var data ="temporary=true&imgBase64=" + es.substring("data:image/jpeg;base64,".length);
            _this.headers = {
                Authorization: "Basic " + Base64.encode(mqttInfo),
                "Content-MD5": _this.$md5(data),
                "Content-Type": "application/x-www-form-urlencoded",
            };
            jq.ajax({
                headers: {
                    Authorization: "Basic " + Base64.encode(mqttInfo),
                    "Content-MD5": _this.$md5(data),
                },
                
                url:up_url_Path,
                type: "POST",
                contentType: "application/x-www-form-urlencoded",
                data: data,
                success: function (res) {
                    Toast.success(_this.$t('scgg'));
                    _this.faceimg.up_img_flag = 1;
                    _this.img = methodlist.resident_pic_base + res;
                    
                },
                error: function (res) {
                    console.log(res)
                    Toast.fail(_this.$t('scsb'));
                },
            });
       }

    },
    canceltailor(data){
        console.log(`3`,data)
    },
    // 图片上传
    
  }
}
</script>
<style scoped>
.selfcents{
    width: 90%;
    margin: 0 auto;
    color:#7F7F7F;
    margin-top: 30px;
    padding-bottom: 100px;
}
.lisone{
    display: flex;
    justify-content: space-evenly;
}
.name{
    display:inline-block;
    width: 70px;
    text-align: right;
    line-height: 30px;
}
.inputsp input{
    height: 32px;
    width: 190px;
    padding:2px 5px;
    border: 1px solid #7F7F7F;
    border-radius:3px ;
    background-color: #fff;
}
.inputsp span{
    margin-left: 5px;
    line-height: 25px;
    color: red;
    font-weight: bold;
    width: 5px;
    display: inline-block;
}
.margin_tops{
    margin-top: 15px;
}
.filediv{
    width: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
}
/* .phone{
    display: flex;
    height: 46px;
    border: 1px solid #DBDBDB;
    margin-bottom: 10px;
    border-radius: 5px;
    padding:0px 2px;
} */
.phone select{
    height: 32px;
    border: none;
    line-height: 32px;
    padding:2px;
    border: 1px solid #7F7F7F;
	border-right: none;
    background-color: #fff;
    color: #323233;
}
.btnn{
    padding: 5px 20px;
    background-color:#1ABC9C ;
    color: #fff;
    border-radius: 3px;
    box-shadow: 1px 1px 1px #7F7F7F;
}
.fileinput-buttom{
    position: relative;
    display: inline-block;
    overflow: hidden;
}
.fileinput-buttom input{
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
}
.inputsp select{
    height: 32px;
    width: 192px;
    border-radius:3px ;
    border: 1px solid #7F7F7F;
    background-color: #fff;
}
.buts{
    margin-top: 40px;
    width: 80px;
    height: 40px;
    border-radius:5px;
}
.upbtn{
    position: absolute;
    left: 0;
    top: 0;
}
.imgs{
    width: 80px;
    height: 80px;
    border-radius:50% ;
}
.cents >>>.van-nav-bar__title{
    color: #fff;
}
.cents>>>.van-nav-bar .van-icon{
    color: #fff;
}
.cents /deep/ .ant-tree ant-tree-icon-hide{
    text-align: left;
}
</style>